import React from 'react';
import { Button } from '@mui/material';
import Grid24 from '../../../components/UI/Grid24';
import DateField from '../../../components/UI/Field/Date/DateField';

function DialogEditarNotaFiscalDevedor({
  setDataEmissao,
  dataEmissao,
  onConfirm,
  onCancel,
}) {
  return (
    <>
      <Grid24 container isFormContainer spacing="1">
        <Grid24 item xs={24} sm={24}>
          <DateField
            label="Data de Emissão"
            name="dataEmissao"
            value={dataEmissao}
            onChange={e => setDataEmissao(e.target.value)}
          />
        </Grid24>
      </Grid24>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '22px' }}>
        <Button
          onClick={() => onCancel()}
        >
          Cancelar
        </Button>
        <Button
          onClick={() => onConfirm()}
        >
          Confirmar
        </Button>
      </div>
    </>
  );
}
export default DialogEditarNotaFiscalDevedor;
